import { combineReducers, createStore, applyMiddleware } from 'redux';
import { Provider, Store } from 'react-redux';
import thunk from 'redux-thunk';
import calendarApiReducer from './reducers/calendar-api';
import { CalendarApiModel, defaultCalendarApiModel } from './reducers/calendar-api';
import * as moment from 'moment';
import { getEvents } from './actions/calendar-api';
 

let combined = combineReducers({
    calendarApiModel: calendarApiReducer
});

var eventsStore = createStore(combined, applyMiddleware(thunk)) as Store<any>;

var previousState = eventsStore.getState();
eventsStore.subscribe(() => {
    const currentState = eventsStore.getState();
    const apiModel = currentState.calendarApiModel as CalendarApiModel;
    const prevApiModel = previousState.calendarApiModel as CalendarApiModel;
    if (apiModel.selectedDate.month() != prevApiModel.selectedDate.month() && !apiModel.requestingEvents) {
        eventsStore.dispatch(getEvents(true))
    }
    if (apiModel.selectedCategory != prevApiModel.selectedCategory && !apiModel.requestingEvents) {
        eventsStore.dispatch(getEvents(true))
    }
    previousState = currentState;
})

export { eventsStore }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/redux/index.ts